<script>
import { generateImpersonationLink } from '@/api/cars'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import Notice from '@/components/cars/edit/Notice.vue'
import ExternalLink from '@/components/ui/ExternalLink.vue'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-external-link': ExternalLink,
    'mia-notice': Notice,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  props: {
    customerId: {
      type: [String, Number],
      required: true
    }
  },

  data: () => ({
    url: ''
  }),

  methods: {
    async onSubmit() {
      this.$wait.start('generating customer portal impersonate link')
      const [error, data] = await generateImpersonationLink(this.customerId)
      this.$wait.end('generating customer portal impersonate link')

      if (error) {
        console.log(error)
        window.eventBus.$emit('mia-error', {
          error: ['Der Anmeldelink konnte nicht erzeugt werden.']
        })
        return
      }

      this.url = data.url
    }
  }
}
</script>

<template>
  <mia-modal
    id="customer-impersonate-modal"
    classes="v--modal flex flex-col"
    width="50%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Anmeldelink erzeugen
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <mia-notice
        permanent
        type="warning"
      >
        <b>Achtung!</b> Mit dem Anmeldelink ist es möglich sich als Kunde im persönlichen Kunden-/Auslieferungsportal anzumelden. Sie führen in diesem Moment alle Aktionen im Namen des Kunden aus!<br>Diese Funktion sollte vor allem dafür verwendet werden, falls der Kunde selbst nicht weiter kommt oder auf einen Fehler gestoßen ist.
      </mia-notice>

      <div
        v-if="url"
        class="mt-4"
      >
        <div class="text-sm italic mb-2">
          *Der Anmeldelink ist nur für eine einmalige Anmeldung gültig!
        </div>

        <mia-external-link
          :href="url"
          target="_blank"
        >
          Jetzt im Kundenportal anmelden
        </mia-external-link>
      </div>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        :disabled="$wait.any"
        size="small"
        @click="$emit('closed')"
      />

      <mia-submit-button
        label="Link erzeugen"
        type="button"
        class="ml-3"
        :disabled="$wait.any"
        :is-loading="$wait.is('generating customer portal impersonate link')"
        size="small"
        @click="onSubmit"
      />
    </mia-modal-footer>
  </mia-modal>
</template>
